import script from "./ServerView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServerView.vue?vue&type=script&setup=true&lang=ts"

import "./ServerView.vue?vue&type=style&index=0&id=c482a5f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_9243d0548d070ce3cb63e50486d60596/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c482a5f2"]])

export default __exports__